<template>
  <div>
    <b-row>
      <b-col>
        <h5 class="bg-light m-0 mb-3 p-2">
          Adjuntos asignados
        </h5>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12" md="6"
      >
        <b-form-group label="Tipo">
          <el-select id="tipoAdjuntoDescarga"
                     v-model="selectedAdjunto.tipo"
          >
            <el-option v-for="tipo in tipos"
                       :value="tipo.value"
                       :label="tipo.text"
                       :key="tipo.value"
            />
          </el-select>
        </b-form-group>
      </b-col>
      <!-- Ubicación -->
      <b-col cosm="12" md="6"  class="form-group">
        <label for="id_ubicacion">
          Ubicación
        </label>
        <tree-select
            v-model="selectedAdjunto.slq_location_id"
            id="slq_location_id"
            name="slq_location_id"
            :multiple="false"
            :defaultExpandLevel="Infinity"
            :options="ubicaciones"
        />
      </b-col>
      <b-col sm="12" md="6">
        <filterProductsFilledComponent
          :onRemoteMethod="onHandleChangeProducts"
          :onSelected="onHandleSelectedProductFilled"
          :onTrashSelected="onHandleTrashSelectedProduct"
          :itemsSelecteds="selectedProductFilleds"
        />
      </b-col>
      <b-col sm="12" md="6">
        <b-form-group label="Disponible en el inventario">
          <el-select id="in_useAdjuntoDescarga" v-model="selectedAdjunto.in_use">
            <el-option value="" label="Todos" />
            <el-option value="1" label="SI" />
            <el-option value="0" label="NO" />
          </el-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="text-center">
        <hr>
        <b-button @click="backRoute()"
                  size="sm"
                  variant="secondary"
                  class="float-left"
        >
          <i class="fa fa-reply fa-lg"></i>
          Volver
        </b-button>
        <b-button v-if="validarPermisoComponente('empresa-editar-descarga-adjuntos')" size="sm"
                  class="mx-1"
                  @click="generarAdjuntos"
                  variant="primary"
                  :disabled="!selectedAdjunto.tipo"
        >
          <i class="fa fa-check"></i>
          Generar
        </b-button>
        <b-button size="sm"
                  class="mx-1"
                  variant="info"
                  @click="_loadProccessBackground()"
        >
          Consultar adjuntos agendados
        </b-button>
      </b-col>
    </b-row>
    <ModalProcessBackground :columns="columns"
                            type="ADJUNTOS-MASIVO"
                            :company_id="selectedEmpresa.id"
                            :title="title"
    />
  </div>
</template>
<script>
import {mapState, mapActions, mapMutations, mapGetters} from 'vuex';
import Swal from 'sweetalert2';
import { getAcls } from '../../plugins/acl';
import TreeSelect from "@riophae/vue-treeselect";
import ModalProcessBackground from "@/shared/background_processes/ModalProcessBackground";
import { loadProccessBackground } from "@/servicios/background_processes/actions";

import filterProductsFilledComponent from '../productos/FilterProductsFilled.vue'
import { validarPermisoComponente } from "@/plugins/acl";

export default {
  name: 'AdjuntosDescarga',
  data: function () {
    return {
      modalAdjuntos: false,
      columns:[
        {key: 'downloadable', label: 'Descargable', sortable: true, tdClass: 'downloadableButton'},
        {key: 'fecha_solicitud', label: 'Fecha de solicitud', sortable: true, tdClass: 'fechaSolicitud'},
        {key: 'fecha_generacion', label: 'Fecha de generación', sortable: true, tdClass: 'fechaGeneracion'},
        {key: 'json.tipoTexto', label: 'Tipo de adjunto', sortable: true, tdClass: 'tipoInventario'},
        {key: 'json.total', label: 'Total  a descargar', sortable: true, tdClass: 'tipoInventario', thStyle: {width: "100px", "min-width": "100px"}},
        {key: 'errores', label: 'Errores del proceso', sortable: true, tdClass: 'estadoGeneracion'},
        {key: 'estado_procesamiento', label: 'Estado de generación', sortable: true, tdClass: 'estadoGeneracion'},
      ],
      title: 'Adjuntos',
      selectedProductFilleds: [],
      validarPermisoComponente: validarPermisoComponente,
    };
  },
  components: {
    TreeSelect,
    ModalProcessBackground,
    filterProductsFilledComponent
  },
  async mounted() {
    await this.getTipo();
    await this.obtenerUbicaciones(this.$route.params.id)
  },
  methods: {
    ...mapActions("tareas", [ "obtenerUbicaciones"]),
    ...mapActions("background_processes", ['loadProccessBackground','generateScheduling']),
    ...mapMutations("background_processes", ['setType']),
    // Acciones del modulo de Productos diligenciados (rpq)
    ...mapActions('productsSearch', [
      'filterProductsFilledInByName'
    ]),
    async _loadProccessBackground() {
      await this.loadProccessBackground({type: 'ADJUNTOS-MASIVO', company_id: this.selectedEmpresa.id}).then( async () =>{
        await this.$bvModal.show('modal_process_background');
      });

    },
    async mostrarAdjuntosAgendados(boolean) {
      this.load(true);
      await this.listarAdjuntosAgendados(this.selectedEmpresa.id);
      this.load(false);
      if (boolean === true) {
        this.modalAdjuntos = true;
      }
    },
    async getTipoAdjunto() {
      await this.getTipo();
    },
    async generarAdjuntos() {
      this.load(true);
      const posicion = this.tipos.findIndex((tipo) => tipo.value === this.selectedAdjunto.tipo);
      if (posicion != -1) {
        const acls = getAcls();
        let data = {
          tipo : this.selectedAdjunto.tipo,
          empresa : this.selectedEmpresa.id,
          tipoTexto : this.tipos[posicion].text,
          uuid :  acls.uuid,
          slq_location_id: this.selectedAdjunto.slq_location_id,
          products: this.selectedProductFilleds.map(x => x.id)
        }

        if (this.selectedAdjunto.in_use == 1 || this.selectedAdjunto.in_use == 0) data.in_use = this.selectedAdjunto.in_use

        this.setType('ADJUNTOS-MASIVO');
        await this.generateScheduling(data);
        await this._loadProccessBackground();
      }
      this.load(false);
    },
    /**
     * Controlar cambios en el select de buscar productos.
     *
     * @author Fernando Claros
     */
    async onHandleChangeProducts(value) {

      await this.filterProductsFilledInByName({
        company_id: this.$route.params.id,
        product_param: value
      });

    },
    /**
     * Seleccionar y agregar el producto a la lista.
     *
     * @author Fernando Claros
     */
    onHandleSelectedProductFilled(lists) {
      this.selectedProductFilleds = lists
    },
    /**
     * Eliminar el producto de la lista.
     *
     * @param {Array} lists
     * @author Fernando Claros
     */
    onHandleTrashSelectedProduct(lists) {
      this.selectedProductFilleds = lists
    },
    backRoute(){
        const currentPath = this.$route.path;
        if (currentPath.includes("/my-company")) {
            this.$router.go(-1);
        }else {
            this.$router.push("/empresas");
        }
    },
    ...mapMutations('adjuntos', ['resetSelectedAdjunto']),
    ...mapMutations('dashboard', ['load']),
    ...mapActions('adjuntos', [
      'getTipo',
      'agendarAdjuntos',
      'listarAdjuntosAgendados'
    ]),
  },
  computed: {
    ...mapState('adjuntos', [
      'selectedAdjunto',
      'tipos',
      'id_empresa',
      'adjuntosProcesados',
      'adjuntos'
    ]),
    ...mapState('empresa', [
      'selectedEmpresa',
      'listadoHistorico',
      'listadoUsuario',
      'listadoDiseno',
      'status',
      'accion',
      'id_creado',
      'error',
      'conexion',
    ]),
    ...mapState("tareas", ["ubicaciones"]),
  }
};
</script>
<style>
@media (min-width: 576px) and (max-width: 991px) {
  .modalAdjuntosMasivo {
    max-width: 90%;
  }
}
.vue-treeselect__no-children-tip {
  display: none !important;
}

.el-input__inner {
  height: 37px;
}

.vue-treeselect__no-children-tip {
  display: none !important;
}

.text-gray {
  color: #7c7c7c;
}

</style>

